// React
import { useEffect, useLayoutEffect, useMemo, useRef, useState } from "react";

// Router
import { useLocation, useNavigate, useParams } from "react-router-dom";

// Redux
import { useDispatch, useSelector } from "react-redux";

import { disableSwitcher } from "../../../redux/features/multiEntitySwitcher/multiEntitySwitcher.js";
import {
  clearrequestTxnError,
  requestTxnReject,
} from "../../../redux/features/reimbursementRequest/index.js";

// Utils
import {
  GlobalConfiguration,
  IntervalConfiguration,
  RejectReasonLength,
} from "../../../utils/configurationProvider.js";
import formatDateViewAll from "../../../utils/formatDateViewAll.js";
import TEXT from "../../../utils/globalText.js";
import formatCurrency from "../../../utils/CurrencyFormater.js";
import useCategories from "../../../utils/useCategories.js";
import accountNameStandardised from "../../../utils/accountNamestandardised.js";

// Components / UI
import TopNavSmallButton from "../../../components/_utils/CommonButtons/TopNavSmallButton/index.jsx";
import { formatAccountNumber } from "../../../components/_utils/FormatAccountNumber/index.js";
import SVGComponent from "../../../components/_utils/SVGComponent/index.jsx";
import FullScreen from "../../../components/FullScreen/index.jsx";
import Loader from "../../../components/Loader/Index.jsx";
import TitleSubtitlePair from "../../../components/_utils/TitleSubtitlePair/index.jsx";
import CommonBankLogo from "../../../components/_utils/CommonBankLogo/index.jsx";
import TimelineStatusBar from "../../../components/_utils/TimelineCommonComponents/TimelineStatusBar/index.jsx";
import SwitcherTabs from "../../../components/_utils/CommonButtons/SwitcherTabs/index.jsx";
import CommonDetailCard from "../../../components/_utils/CommonDetailCard/index.jsx";
import CommonToast from "../../../components/_utils/CommonToast/index.jsx";
import ICONS from "../../../assets/Icons/index.js";
import LargePopupRedirect from "../../../components/_utils/CommonPopups/CommonLargePopupRedirect/index.jsx";
import SmallPopupWithInput from "../../../components/_utils/CommonSmallPopupWithInput/index.jsx";
import CommonTimeLineCard, {
  addLifeCycleStatus,
} from "../../../components/CommonTimeLineCard/index.jsx";
import OwnerAccountDetailsPopUp from "../../../components/Accounts/OwnerAccountDetailsPopUp/index.jsx";
import { toast_position } from "../../../redux/features/Settings/Authorization/index.js";
import TimelinePopupContent from "../../../components/_utils/TimelinePopupContent/index.jsx";
import { toast } from "react-toastify";
import {
  fieldforcerequestTxnReject,
  getSpecificFieldForceRequest,
} from "../../../redux/features/fieldForceRequest/index.js";
// import FieldForceRequestViewAllPopup from "../../../components/FieldForceRequestTransactionComp/FieldForceRequestViewAllPopup/index.jsx";
import FieldForceAccDetailPagePopup from "../../../components/FieldForceAccount/FieldForceAccDetailPagePopup/index.jsx";
import FieldForceAccountDetailsPopup from "../../../components/_utils/FieldForceAccountDetailsPopup/index.jsx";
import FieldForceRequestViewAllPopup from "../../../components/FieldForceTransactionComp/FieldForceRequestViewAllPopup/index.jsx";

const FieldForceTxnRequestDetail = ({
  isPopup,
  txn_id,
  detailSelected,
  reimburse_request_id,
  type,
  closePopup,
  flow,
}) => {
  // useDispatch, useNavigate, useParams (and id from params)
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();
  const previousStatus = useLocation()?.state?.options?.state;

  // useRef
  const leftContentRef = useRef(null);
  const cardRefs = useRef({});

  //useState
  const [RequestHistory, setRequestHistory] = useState(false);
  const [RequestAccName, setRequestAccName] = useState("");
  const [scheduleUpdatedData, setScheduleUpdatedData] = useState([]);
  const [timelinedatabottom, setTimelinedatabottom] = useState([]);
  const [isloading, setIsLoading] = useState(true);
  const [alertPopUp, setAlertPopUp] = useState(false);
  const [doneBinding, setDoneBinding] = useState(false);
  const [BeneAccountId, setBeneAccountId] = useState("");
  const [showRejectPrompt, setShowRejectPrompt] = useState(false);
  const [requestId, setRequestId] = useState("");
  const [showRequestAccModal, setShowRequestAccModal] = useState(false);
  const [OwnerDetailpop, setOwnerDetailpop] = useState(false);
  const [ReimburseAccountDetailpop, setReimburseAccountDetailpop] =
    useState(false);
  const [selectedDetail, setSelectedDetail] = useState(
    flow === "request_additional" || detailSelected === "Additional details"
      ? "Additional details"
      : "Details",
  );

  const [showDetails, setShowDetails] = useState(true);
  const [rightHeight, setRightHeight] = useState("auto");
  const [showLoader, setShowLoader] = useState(false);
  const [declineReason, setDeclineReason] = useState("");
  const [inputDisabled, setInputDisabled] = useState(false);
  const [showLabelsPopup, setShowLabelsPopup] = useState(false);
  const [labels, setLabels] = useState([]);
  const [showLabel, setShowLabel] = useState(false);
  const [labelDetails, setLabelDetails] = useState([]);
  const [RequestCategoryName, setRequestCategoryName] = useState("");
  const [opentimelinepopup, SetopenTimelinePopup] = useState(false);
  const [showApprovalTimeline, setShowApprovalTimeline] = useState(false);
  const [openApprovalTimeline, setOpenApprovalTimeline] = useState(
    Array(scheduleUpdatedData?.[0]?.logs?.length || 0).fill(false),
  );
  const [currentAccountDetails, setcurrentAccountDetails] = useState({
    bankAccountName: "",
    beneAccountId: "",
    bankAccountIFSC: "",
    bankAccountNo: "",
    categories: "",
    amount: "",
    settleType: "",
    bankLogo: "",
    pan: "",
    ownerId: null,
    ownerAccountName: "",
    ownerBankIFSC: null,
    ownerBankBalance: GlobalConfiguration.lengthCheckZero,
    ownerBankLogo: null,
    ownerLastUpdated: null,
    ownerBankAccountNo: null,
    selectedCategory: null,
    mergeCategory: null,
    amountWords: "",
    labels: [],
    ownerLabels: [],
    comment: "",
    date: "",
    expenseType: "",
    description: "",
    uploadFile: "",
  });
  const [btnClicked, setbtnClicked] = useState({});
  const [loading, setLoading] = useState(false);
  const [tabIndex, setTabIndex] = useState(
    flow === "request_additional"
      ? GlobalConfiguration.lengthCheckOne
      : GlobalConfiguration?.lengthCheckZero,
  );
  const [prevIndex, setPrevIndex] = useState(
    GlobalConfiguration?.lengthCheckZero,
  );
  const [animationClass, setAnimationClass] = useState("");

  //  useSelector
  const services = useSelector((state) => state.refreshToken.services);
  const {
    fieldForceRequestDetailsData,
    requestTxnRejectLoading,
    requestTxnRejectError,
  } = useSelector((s) => s.fieldForceRequest);

  //  Constants (hooks / derived)
  const categoryMapper = useCategories();
  const hasModService = services?.includes("AFieldForceRequest");

  //useLayoutEffect
  useLayoutEffect(() => {
    if (!leftContentRef.current) return;

    const updateHeight = () => {
      setRightHeight(leftContentRef?.current?.offsetHeight);
    };

    updateHeight();

    window.addEventListener("resize", updateHeight);
    return () => window.removeEventListener("resize", updateHeight);
  }, [scheduleUpdatedData]);

  //useEffect
  useEffect(() => {
    return () => {
      dispatch(clearrequestTxnError());
    };
  }, []);

  // Callbacks
  const toggleAdditionalDetails = () => {
    setSelectedDetail("Additional details");

    setTabIndex(GlobalConfiguration?.lengthCheckOne);
    setShowDetails(false);
    setShowLabel(false);
  };
  const toggleLabels = () => {
    setSelectedDetail("Labels");
    setShowLabel(true);
    setTabIndex(GlobalConfiguration?.lengthCheckTwo);
    setShowDetails(false);
  };
  const toggleDetails = () => {
    setSelectedDetail("Details");
    setShowDetails(true);
    setTabIndex(GlobalConfiguration?.lengthCheckZero);

    setShowLabel(false);
  };
  const handleBeneAccModalClose = () => {
    setShowRequestAccModal(false);
    // dispatch(
    //   getSpecificFieldForceRequest({
    //     id,
    //     services,
    //     navigate,
    //   }),
    // );
    dispatch(getSpecificFieldForceRequest(reimburse_request_id || id));
  };

  useLayoutEffect(() => {
    if (tabIndex !== prevIndex) {
      const direction =
        tabIndex > prevIndex ? "animate-slide-next" : "animate-slide-prev";

      setAnimationClass(direction);
      setPrevIndex(tabIndex);
    }
  }, [tabIndex]);

  const imageStyle = {
    width: "var(--icon-lg)",
    height: "var(--icon-lg)",
    Opacity: "var(--base-opacity)",
  };

  const handleInputChange = (event) => {
    const value = event.target.value;

    const sanitizedValue = value.replace(/[^a-zA-Z0-9\s]/g, "");

    const limitedValue = sanitizedValue.slice(
      GlobalConfiguration.lengthCheckZero,
      RejectReasonLength.lengthOfDecline,
    );

    setDeclineReason(limitedValue);
  };

  const handleConfirm = async (id, AccountIdData) => {
    setShowLoader(true);
    setInputDisabled(true);
    setShowRejectPrompt(false);
    CommonToast({
      text: "Request rejecting",
      icon: ICONS.INFO_FILLED,
      variant: "var(--processing)",
    });
    try {
      if (!requestTxnRejectLoading) {
        const result = await dispatch(
          fieldforcerequestTxnReject({ request_ids: [id], AccountIdData }),
        );

        // 3. Wait for the required interval
        await new Promise((resolve) =>
          setTimeout(resolve, IntervalConfiguration.intervalExtraLarge),
        );

        if (result?.payload?.status === false) {
          const error_msg =
            result?.payload?.errors?.base?.[0]?.errors ||
            result?.payload?.errors?.bank_account_number?.[0] ||
            result?.payload?.errors?.category?.[0] ||
            "An unknown error occurred.";

          CommonToast({
            text: error_msg,
            icon: "https://q2pay.in/new_assets/common/create_flow/error_with_white_circle.svg",
            variant: "var(--error)",
          });
        } else {
          CommonToast({
            text: "Request rejected successfully.",
            icon: "https://q2pay.in/new_assets/common/approval/select_all_with_white_filled_circle.svg",
            variant: "var(--success)",
          });

          await dispatch(
            getSpecificFieldForceRequest(reimburse_request_id || id),
          );
        }
      }
    } catch (error) {
      console.error("Critical Rejection Error:", error);
      CommonToast({ text: "System error occurred", variant: "var(--error)" });
    } finally {
      setShowLoader(false);
      setInputDisabled(false);
      setDeclineReason("");
      setbtnClicked((prev) => ({
        ...prev,
        [id]: "none",
      }));
    }
  };

  const renderDetailSection = () => {
    if (isloading) return null;

    if (!fieldForceRequestDetailsData?.request?.length) {
      return (
        <div className="text-text-secondary text-font-sm p-padding-md">
          No transaction data available.
        </div>
      );
    }

    switch (tabIndex) {
      // ===================== DETAILS =====================
      case GlobalConfiguration?.lengthCheckZero:
        return fieldForceRequestDetailsData?.request?.map((account) => {
          const originItemList = [
            {
              heading: "Created by",
              content: (
                (account?.logs?.[0]?.first_name || "") +
                " " +
                (account?.logs?.[0]?.last_name || "")
              )
                .toLowerCase()
                .split(" ")
                .filter(Boolean)
                .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
                .join(" "),
              type: "text",
            },
            {
              heading: "Created on",
              content: formatDateViewAll(
                fieldForceRequestDetailsData?.request?.[0]?.created_on,
                true,
                true,
              ),
              type: "text",
            },
          ];

          if (account?.created_via) {
            originItemList.push({
              heading: "Created via",
              content: account.created_via,
              type: "text",
            });
          }

          const supportItemList = [
            {
              content: account?.request_id,
              heading: "Request ID",
              type: "text",
            },
          ];

          const reimbursementItemList = [
            {
              heading: "Expense type",
              content:
                account?.expense_type?.[0]?.toUpperCase() +
                  account?.expense_type?.slice(1).toLowerCase() || "N/A",
              type: "text",
            },
            {
              heading: "Expense date",
              content:
                formatDateViewAll(account?.created_on, false, false) || "N/A",
              type: "text",
            },
          ];

          if (account.uploaded_file_data) {
            const file = account.uploaded_file_data;
            const mimeType =
              file.metadata?.mime_type ?? "application/octet-stream";

            const isImage = ["image/png", "image/jpeg", "image/jpg"].includes(
              mimeType.toLowerCase(),
            );

            reimbursementItemList.push({
              heading: "Upload file",
              type: isImage ? "image" : "file",
              content: {
                fileName: file.metadata.filename,
                size: file.metadata.size ?? "0",
                mimeType,
                url: account?.uploaded_file_url,
              },
            });

            reimbursementItemList.push({
              heading: "Description (optional)",
              content: account?.description || "Not given",
              type: "text",
            });
          }

          return (
            <div
              key={tabIndex}
              className={animationClass}
            >
              <div
                key={account.request_id}
                className="flex flex-col lg:flex-row mb-margin-md px-padding-md lg:px-padding-base gap-gap-md"
              >
                <CommonDetailCard
                  cardTitle={TEXT?.ORIGIN_DETAILS}
                  variant="third"
                  numCols={GlobalConfiguration?.lengthCheckOne}
                  entries={originItemList}
                />

                <CommonDetailCard
                  cardTitle="Field Force Details"
                  variant="third"
                  numCols={GlobalConfiguration?.lengthCheckOne}
                  entries={reimbursementItemList}
                />

                <CommonDetailCard
                  cardTitle="Support information"
                  variant="third"
                  numCols={GlobalConfiguration?.lengthCheckOne}
                  entries={supportItemList}
                />
              </div>
            </div>
          );
        });

      // ===================== ADDITIONAL DETAILS =====================
      // case GlobalConfiguration?.lengthCheckOne: {
      //   const allAdditionalData = fieldForceRequestDetailsData.request.flatMap(
      //     (txn) => txn.additional_data?.data ?? [],
      //   );

      //   const attachments = allAdditionalData.filter((item) =>
      //     ["hyperlink", "upload"].includes(item.data_type),
      //   );

      //   if (!allAdditionalData.length) {
      //     return (
      //       <div
      //         key={tabIndex}
      //         className={animationClass}
      //       >
      //         <div className="w-details-card-md flex flex-col p-padding-md gap-gap-md bg-primary-card rounded-border-radius-md">
      //           <div className="text-text-primary text-font-sm font-semibold">
      //             {TEXT?.ADDITIONAL_DETAILS}
      //           </div>
      //           <p className="text-text-secondary text-font-xs font-normal">
      //             Additional details are not supported for the selected
      //             category.
      //           </p>
      //         </div>
      //       </div>
      //     );
      //   }

      //   const attachmentEntries = attachments
      //     .map((obj) => {
      //       if (obj.data_type === "hyperlink" && obj.value) {
      //         return {
      //           heading: "URL",
      //           content: obj.value,
      //           type: "link",
      //         };
      //       }

      //       if (obj.data_type === "upload") {
      //         const file = obj.value;
      //         if (!file?.metadata) return null;

      //         const mt = (
      //           file.metadata.mime_type ?? "application/octet-stream"
      //         ).toLowerCase();

      //         const isImage = ["image/png", "image/jpeg", "image/jpg"].includes(
      //           mt,
      //         );

      //         return {
      //           heading: isImage ? "Image" : "File",
      //           type: isImage ? "image" : "file",
      //           content: {
      //             fileName: file.metadata.filename,
      //             size: file.metadata.size ?? "0",
      //             mimeType: mt,
      //             url: file.file_url || file.id,
      //           },
      //         };
      //       }

      //       return null;
      //     })
      //     .filter(Boolean);

      //   return (
      //     <div
      //       key={tabIndex}
      //       className={animationClass}
      //     >
      //       <div className="flex flex-col lg:flex-row items-start gap-gap-md pb-padding-md text-text-primary px-padding-md lg:px-padding-base">
      //         <CommonDetailCard
      //           cardTitle={TEXT?.ADDITIONAL_DETAILS}
      //           variant="third"
      //           numCols={
      //             allAdditionalData.length ===
      //             GlobalConfiguration?.lengthCheckOne
      //               ? GlobalConfiguration?.lengthCheckOne
      //               : GlobalConfiguration?.lengthCheckTwo
      //           }
      //           entries={allAdditionalData
      //             .map((item) => {
      //               if (item.data_type === "from_year_to_year") {
      //                 const { from, to } = item.value || {};
      //                 return {
      //                   heading: item.name,
      //                   content: from && to ? `${from} - ${to}` : "Not Given",
      //                   type: "text",
      //                 };
      //               }

      //               if (item.data_type === "date_range") {
      //                 const { start_date, end_date } = item.value || {};
      //                 return {
      //                   heading: item.name,
      //                   content:
      //                     start_date && end_date
      //                       ? `${start_date} - ${end_date}`
      //                       : "Not Given",
      //                   type: "text",
      //                 };
      //               }

      //               if (
      //                 ![
      //                   "hyperlink",
      //                   "upload",
      //                   "multi_select_list",
      //                   "toggle",
      //                 ].includes(item.data_type)
      //               ) {
      //                 return {
      //                   heading: item.name,
      //                   content: item?.value ? item?.value : "Not Given",
      //                   type: "text",
      //                 };
      //               }

      //               if (item.data_type === "multi_select_list") {
      //                 return {
      //                   heading: item.name,
      //                   content: item.value?.length
      //                     ? item.value.join(", ")
      //                     : "Not Given",
      //                   type: "text",
      //                 };
      //               }

      //               if (item.data_type === "toggle") {
      //                 return {
      //                   heading: item.name,
      //                   content: item.value ? "Yes" : "No",
      //                   type: "text",
      //                 };
      //               }

      //               return null;
      //             })
      //             .filter(Boolean)}
      //         />

      //         {attachmentEntries.length >
      //           GlobalConfiguration?.lengthCheckZero && (
      //           <CommonDetailCard
      //             cardTitle={TEXT?.ATTACHMENTS}
      //             variant="third"
      //             numCols={GlobalConfiguration?.lengthCheckOne}
      //             entries={attachmentEntries}
      //           />
      //         )}
      //       </div>
      //     </div>
      //   );
      // }

      case GlobalConfiguration?.lengthCheckOne: {
        const allAdditionalData = fieldForceRequestDetailsData.request.flatMap(
          (txn) => txn.additional_data?.data ?? [],
        );

        const attachments = allAdditionalData.filter((item) =>
          ["hyperlink", "upload"].includes(item.data_type),
        );

        const filteredItems = allAdditionalData.filter(
          (item) => !["hyperlink", "upload"].includes(item.data_type),
        );

        if (!allAdditionalData.length) {
          return (
            <div
              key={tabIndex}
              className={animationClass}
            >
              <div className="w-details-card-md flex flex-col p-padding-md gap-gap-md bg-primary-card rounded-border-radius-md">
                <div className="text-text-primary text-font-sm font-semibold">
                  {TEXT?.ADDITIONAL_DETAILS}
                </div>
                <p className="text-text-secondary text-font-xs font-normal">
                  Additional details are not supported for the selected
                  category.
                </p>
              </div>
            </div>
          );
        }

        const attachmentEntries = attachments
          .map((obj) => {
            if (obj.data_type === "hyperlink" && obj.value) {
              return { heading: "URL", content: obj.value, type: "link" };
            }
            if (obj.data_type === "upload") {
              const file = obj.value;
              if (!file?.metadata) return null;
              const mt = (
                file.metadata.mime_type ?? "application/octet-stream"
              ).toLowerCase();
              const isImage = ["image/png", "image/jpeg", "image/jpg"].includes(
                mt,
              );
              return {
                heading: isImage ? "Image" : "File",
                type: isImage ? "image" : "file",
                content: {
                  fileName: file.metadata.filename,
                  size: file.metadata.size ?? "0",
                  mimeType: mt,
                  url: file.file_url || file.id,
                },
              };
            }
            return null;
          })
          .filter(Boolean);

        return (
          <div
            key={tabIndex}
            className={animationClass}
          >
            <div className="flex flex-col lg:flex-row items-start gap-gap-md pb-padding-md text-text-primary px-padding-md lg:px-padding-base">
              {!!filteredItems.length && (
                <CommonDetailCard
                  cardTitle={TEXT?.ADDITIONAL_DETAILS}
                  variant="third"
                  numCols={
                    filteredItems.length === GlobalConfiguration?.lengthCheckOne
                      ? GlobalConfiguration?.lengthCheckOne
                      : GlobalConfiguration?.lengthCheckTwo
                  }
                  entries={filteredItems
                    .map((item) => {
                      if (item.data_type === "from_year_to_year") {
                        const { from, to } = item.value || {};
                        return {
                          heading: item.name,
                          content: from && to ? `${from} - ${to}` : "Not Given",
                          type: "text",
                        };
                      }
                      if (item.data_type === "date_range") {
                        const { start_date, end_date } = item.value || {};
                        return {
                          heading: item.name,
                          content:
                            start_date && end_date
                              ? `${start_date} - ${end_date}`
                              : "Not Given",
                          type: "text",
                        };
                      }
                      if (item.data_type === "multi_select_list") {
                        return {
                          heading: item.name,
                          content: item.value?.length
                            ? item.value.join(", ")
                            : "Not Given",
                          type: "text",
                        };
                      }
                      if (item.data_type === "toggle") {
                        return {
                          heading: item.name,
                          content: item.value ? "Yes" : "No",
                          type: "text",
                        };
                      }
                      return {
                        heading: item.name,
                        content: item?.value ? item?.value : "Not Given",
                        type: "text",
                      };
                    })
                    .filter(Boolean)}
                />
              )}

              {attachmentEntries.length >
                GlobalConfiguration?.lengthCheckZero && (
                <CommonDetailCard
                  cardTitle={TEXT?.ATTACHMENTS}
                  variant="third"
                  numCols={GlobalConfiguration?.lengthCheckOne}
                  entries={attachmentEntries}
                />
              )}
            </div>
          </div>
        );
      }

      default:
        return null;
    }
  };

  useEffect(() => {
    dispatch(disableSwitcher());
  }, [services, id, navigate]);

  useEffect(() => {
    fetchData();
    const availableLabels = sessionStorage?.getItem("AvailableLabelsRequest");
    const parsedLabels = JSON?.parse(availableLabels);
    setLabels(parsedLabels);
  }, [id, reimburse_request_id]);

  // useEffect(() => {
  //   if (
  //     Array.isArray(scheduleUpdatedData?.request) &&
  //     scheduleUpdatedData.request.length
  //   ) {
  //     const data = scheduleUpdatedData.request[0];
  //     if (type === "reimbursereq_details") {
  //       if (data?.request_id !== reimburse_request_id) return;
  //     } else {
  //       if (data?.request_id !== id) return;
  //     }
  //     setDoneBinding(true);
  //   }
  // }, [scheduleUpdatedData, id]);

  const categoryIcon = useMemo(() => {
    return fieldForceRequestDetailsData?.request?.[0]?.category
      ? categoryMapper(fieldForceRequestDetailsData?.request?.[0]?.category)
      : null;
  }, [fieldForceRequestDetailsData?.request?.[0]?.category]);

  // useEffect(() => {
  //   if (showTLModal || showRejectPrompt || showRequestAccModal) {
  //     document.body.style.overflow = "hidden";
  //   } else {
  //     document.body.style.overflow = "auto";
  //   }
  //   return () => {
  //     document.body.style.overflow = "auto";
  //   };
  // }, [showTLModal, showRejectPrompt, showRequestAccModal]);
  // useEffect(() => {
  //   const el = document.querySelector(".main_div");
  //   el?.scrollTo({ top: 100, behavior: "smooth" });
  // }, []);

  const quickActions = (
    <>
      <div className="flex flex-col w-width-full my-margin-md">
        <div className="py-padding-sm px-padding-md bg-primary-card text-font-sm text-text-primary text-left font-semibold w-width-full">
          Quick Action
        </div>

        {(() => {
          const buttonsTop = [];
          const buttonsBottom = [];

          buttonsTop.push(
            <TopNavSmallButton
              key="Request-history"
              btnText={
                <>
                  Request <br /> history
                </>
              }
              btnType="button"
              icon={
                "https://q2pay.in/new_assets/common/detail_page/transaction_history.svg"
              }
              handleFunction={() => {
                if (isPopup) {
                  CommonToast({
                    text: "Action restricted in popup mode.",
                    icon: "https://q2pay.in/new_assets/common/create_flow/error_with_white_circle.svg",
                    variant: "var(--error)",
                  });
                  return;
                } else {
                  setRequestHistory(true);
                  setRequestId(
                    fieldForceRequestDetailsData?.request?.[0]
                      ?.field_force_account_id,
                  );
                  setRequestAccName(
                    fieldForceRequestDetailsData?.request?.[0]
                      ?.field_force_account_name,
                  );
                }
                // toast.info("Coming Soon...", toast_position);
              }}
              isDisabled={isPopup}
              enabledTextColor="var(--text-primary)"
              enabledBgColor="var(--primary-nav-act)"
              disabledBgColor="var(--primary-nav-act)"
              disabledTextColor="var(--text-primary)"
              hoverOption="white"
              fullWidthRequired
            />,
          );

          if (
            fieldForceRequestDetailsData?.request?.[0]?.lifecycle_status ===
            "approved"
          ) {
            buttonsTop.push(
              <TopNavSmallButton
                btnText={
                  <>
                    Linked <br /> transaction
                  </>
                }
                icon={
                  "https://q2pay.in/new_assets/common/detail_page/linked_white_circle.svg"
                }
                hoverOption={"white"}
                enabledBgColor={"var(--primary-nav-act)"}
                enabledTextColor={"var(--text-primary)"}
                disabledBgColor={"var(--primary-nav-act)"}
                disabledTextColor={"var(--text-primary)"}
                fullWidthRequired
                handleFunction={() => {
                  // navigate(
                  //   `/field_force_transaction_dashboard/field_force_transaction_view_all/field_force_transaction_detail_page/${fieldForceRequestDetailsData?.request?.[0]?.field_force_transactions_details?.field_force_transaction_id}`,
                  // );
                  toast.info("Coming Soon...", toast_position);
                }}
                isDisabled={isPopup}
              />,
            );
          }

          buttonsBottom.push(
            <TopNavSmallButton
              btnText={fieldForceRequestDetailsData?.request?.[0]?.category}
              btnType="button"
              icon={categoryIcon}
              handleFunction={() => {
                if (isPopup) {
                  CommonToast({
                    text: "Action restricted in popup mode.",
                    icon: "https://q2pay.in/new_assets/common/create_flow/error_with_white_circle.svg",
                    variant: "var(--error)",
                  });
                  return;
                } else {
                  setRequestHistory(true);
                  setRequestCategoryName(
                    fieldForceRequestDetailsData?.request?.[0]?.category,
                  );
                  setRequestAccName(
                    fieldForceRequestDetailsData?.request?.[0]
                      ?.field_force_account_name,
                  );
                  setRequestId(
                    fieldForceRequestDetailsData?.request?.[0]
                      ?.field_force_account_id,
                  );
                }
                // toast.info("Coming Soon...", toast_position);
              }}
              isDisabled={isPopup ? true : false}
              enabledTextColor="var(--text-primary)"
              enabledBgColor="var(--primary-nav-act)"
              disabledBgColor="var(--primary-nav-act)"
              hoverOption="white"
              fullWidthRequired={true}
            />,
          );

          return (
            <>
              <div
                className={`grid w-width-full bg-primary-nav ${
                  buttonsTop.length === GlobalConfiguration?.lengthCheckOne
                    ? "grid-cols-1"
                    : "grid-cols-2"
                } border-b ${
                  buttonsBottom.length > GlobalConfiguration?.lengthCheckZero
                    ? "border-primary-bg"
                    : "border-none"
                }`}
              >
                {buttonsTop.map((btn, index) => (
                  <div
                    key={index}
                    className="relative border-r border-primary-bg last:border-none"
                  >
                    {btn}
                  </div>
                ))}
              </div>

              {/* Bottom Row (Confidential full width if exists) */}
              {buttonsBottom.length > GlobalConfiguration?.lengthCheckZero && (
                <div className=" w-width-full bg-primary-nav">
                  {buttonsBottom.map((btn, index) => (
                    <div
                      key={index}
                      className="relative border-r border-primary-bg last:border-none"
                    >
                      {btn}
                    </div>
                  ))}
                </div>
              )}
            </>
          );
        })()}
      </div>
    </>
  );

  async function fetchData() {
    setIsLoading(true);
    try {
      let response;

      response = await dispatch(
        getSpecificFieldForceRequest(reimburse_request_id || id),
      );

      setLabelDetails(response?.payload?.request?.[0]?.labels || []);
      if (response?.error?.message === "Request failed with status code 404") {
        navigate("/*");
      }
    } catch (error) {
      error("Failed to load the account details", error);
    } finally {
      setIsLoading(false);
    }
  }

  const closeHistory = () => {
    setRequestHistory(false);
    setRequestAccName("");
    setRequestId("");
    setRequestCategoryName("");
  };

  const handleApprovalTimeline = (index) => {
    setOpenApprovalTimeline((prevOpenDivs) => {
      if (!Array.isArray(prevOpenDivs)) {
        return [];
      }
      const newOpenDivs = [...prevOpenDivs];
      newOpenDivs[index] = !newOpenDivs[index];
      return newOpenDivs;
    });

    if (!openApprovalTimeline[index]) {
      setTimeout(() => {
        cardRefs.current[index]?.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      }, IntervalConfiguration.intervalExtraSmall);
    }
  };
  const handleTimelinePopup = () => {
    SetopenTimelinePopup(true);
    setShowApprovalTimeline(true);
    // toast.info("Coming Soon...", toast_position);
  };
  const PopupcloseIcons = () => {
    setOpenApprovalTimeline([]);
    SetopenTimelinePopup(false);
    setShowApprovalTimeline(false);
  };
  const renderApprovalData = (obj) => {
    return Object.keys(obj).map((key, index, array) => {
      const isLastItem =
        index === array.length - GlobalConfiguration?.lengthCheckZero;
      if (key !== "action") {
        return (
          <>
            <div
              key={key}
              className={`flex flex-row items-center ${
                !isLastItem ? "mb-margin-md" : ""
              }`}
            >
              <div className="w-icon-xs border-b-border border-solid border-text-secondary"></div>

              <p
                key={key}
                className="w-width-full text-text-secondary text-sm text-left font-normal ml-margin-xs make-first-letter-small break-words"
              >{`"${key}": "${obj[key]}"`}</p>
            </div>
          </>
        );
      }
      return null;
    });
  };

  useEffect(() => {
    if (!fieldForceRequestDetailsData) return;

    const uiState = addLifeCycleStatus({
      lifecycle_status:
        fieldForceRequestDetailsData?.request?.[0]?.lifecycle_status,
      services,
      previousStatus: previousStatus,
    });

    const newData = {
      ...fieldForceRequestDetailsData,
      transaction: fieldForceRequestDetailsData?.request?.map((account) => ({
        ...account,
        loading: false,
        error: false,
        message: "",
        last_updated_user_id_check: false,
        ...uiState,
      })),
    };

    // setTimelinedatabottom(newData);

    setScheduleUpdatedData(newData);

    setDoneBinding(true);
  }, [fieldForceRequestDetailsData, services]);
  const rejectErrorMessage = requestTxnRejectError?.errors?.base?.[0]?.errors;

  return (
    <>
      {/* GLOBAL FULL-SCREEN LOADER */}
      {showLoader && (
        <div className="fixed inset-0 w-screen h-screen flex items-center justify-center z-[9999] bg-custom-backdrop bg-opacity-dark-opacity">
          {/* <div className="flex justify-center items-center">
            <Loader />
          </div> */}
        </div>
      )}
      <div
        className={`  flex flex-col overflow-x-hidden  ${!isPopup ? "overflow-y-auto  h-screen" : "h-full"}`}
      >
        {RequestHistory && (
          <>
            <div className="fixed top-top-base left-left-base w-width-full h-height-full flex items-center bg-PopUp-BackDrop justify-center z-z-index-modal bg-opacity-dark-opacity">
              <FieldForceRequestViewAllPopup
                closeReimburseTxnDetailsModal={closeHistory}
                TxnHistoryid={requestId}
                TxnHistoryAccountName={RequestAccName}
                categoryName={RequestCategoryName}
                type={"requestViewallPopup"}
              />
            </div>
          </>
        )}
        {OwnerDetailpop && (
          <div className="fixed top-top-base left-left-base w-screen h-screen z-z-index-modal bg-Primary-black bg-opacity-dark-opacity">
            <OwnerAccountDetailsPopUp
              closeBeneAccountDetailModal={() => {
                setOwnerDetailpop(false);
              }}
              Remibursement_owneraccount_id={
                fieldForceRequestDetailsData?.request?.[0]?.owner_account_id
              }
              type={"reimburseowner_details"}
            />
          </div>
        )}
        {ReimburseAccountDetailpop && (
          <div className="fixed top-top-base left-left-base w-screen h-screen z-z-index-modal bg-Primary-black bg-opacity-dark-opacity">
            <FieldForceAccDetailPagePopup
              closeFieldForceAccountDetailModal={() => {
                setReimburseAccountDetailpop(false);
              }}
              field_force_account_id={BeneAccountId}
              // type="field_force_account_detail_modal"
            />
          </div>
        )}

        {showRejectPrompt && (
          <div className="fixed top-top-base left-left-base w-full h-full bg-custom-backdrop bg-opacity-dark-opacity flex items-center justify-center z-z-index-modal">
            <SmallPopupWithInput
              headerTitle="Rejected reason"
              headerFontWeight="semibold"
              headerFontColor="text-primary"
              textSize="font-md"
              secondHeaderTitle="Please state the reason for rejecting the transaction."
              secondHeaderFontWeight="normal"
              secondHeaderFontColor="text-secondary"
              secondHeaderTextSize="font-xs"
              noteColor="text-secondary"
              inputPlaceholder={TEXT.REASON_10_150_CHAR}
              inputVariant={
                declineReason &&
                declineReason.length > GlobalConfiguration.accountnormalLength
                  ? "verified"
                  : declineReason &&
                      declineReason.length <
                        GlobalConfiguration.owneraccountnormalLength
                    ? "typing"
                    : "default"
              }
              inputIsDisabled={showLoader ? true : false}
              btnOneIsDisabled={showLoader ? true : false}
              inputBgColor="var(--primary-bg)"
              inputFgColor="var(--text-secondary)"
              inputOnInput={(e) => {
                if (!showLoader) {
                  handleInputChange(e);
                }
              }}
              inputValue={declineReason}
              inputFontKind="small"
              inputIsFullWidth={true}
              btnOneText="Cancel"
              btnOneHandleFunction={() => {
                if (!showLoader) {
                  setbtnClicked((prev) => ({
                    ...prev,
                    [fieldForceRequestDetailsData?.request?.[0]?.request_id]:
                      "none",
                  }));
                  setShowRejectPrompt(false);
                  setDeclineReason("");

                  setbtnClicked((prev) => ({
                    ...prev,
                    [fieldForceRequestDetailsData?.request?.[0]?.request_id]:
                      "none",
                  }));
                }
              }}
              btnOneEnabledBgColor="var(--primary-bg)"
              btnOneOutLineColor="var(--text-primary)"
              btnOneEnabledTextColor="var(--text-primary)"
              btnOneHoverOption="white"
              btnTwoText="Reject"
              btnTwoHandleFunction={() => {
                handleConfirm(
                  fieldForceRequestDetailsData?.request?.[0]?.request_id,
                  declineReason,
                );
              }}
              btnTwoEnabledBgColor="var(--negative-act)"
              btnTwoEnabledTextColor="var(--text-primary)"
              btnTwoIsDisabled={
                !declineReason ||
                declineReason.length <
                  GlobalConfiguration.owneraccountnormalLength
              }
              btnTwoDisabledBgColor="var(--text-disabled)"
              btnTwoIsLoaderNeeded={showLoader ? true : false}
              btnTwoIsLoading={showLoader ? true : false}
              btnTwoHoverOption="black"
            />
          </div>
        )}
        {opentimelinepopup && (
          <div className="fixed top-top-base left-left-base w-width-full h-height-full flex items-center bg-PopUp-BackDrop justify-center z-z-index-modal bg-opacity-dark-opacity">
            <LargePopupRedirect
              headerTitle="Request timeline"
              headerFontWeight="semibold"
              headerFontColor="text-primary"
              headertextSize="font-md"
              closeiconenabledBgColor="var(--primary-nav)"
              closeiconisLoading={false}
              closeiconhandleFunction={PopupcloseIcons}
              closeicon="https://q2pay.in/new_assets/common/create_flow/close.svg"
              closeiconhoverOption="white"
              closeiconbtnType="button"
              closeiconisDisabled={false}
              closeicondisabledBgColor=""
              closeiconbuttonRef={null}
              closeicontitle="Close"
              btnType="button"
              handleFunction={() => {}}
              enabledBgColor="var(--positive-act)"
              hoverOption="dark"
              outLineColor=""
              enabledTextColor="var(--text-primary)"
              fullWidthRequired={false}
              isDisabled={false}
              disabledTextColor=""
              disabledBgColor=""
              isLoading={false}
              buttonRef={null}
              inActiveVariantNeeded={false}
              isLoaderNeeded={false}
              isscrollRequired={true}
            >
              <TimelinePopupContent
                logsData={scheduleUpdatedData?.transaction}
                handleApprovalClick={handleTimelinePopup}
                showDistributionRightIcon={false}
                showApprovalLeftIcon={false}
                showApprovalTimeline={showApprovalTimeline}
                openApprovalTimeline={openApprovalTimeline}
                handleApprovalTimeline={handleApprovalTimeline}
                setOpenApprovalTimeline={setOpenApprovalTimeline}
                cardType={"single"}
                popUpMode={true}
              />
            </LargePopupRedirect>
          </div>
        )}
        {showRequestAccModal && (
          <div
            className="fixed top-top-base left-left-base w-screen h-screen z-z-index-modal bg-custom-backdrop bg-opacity-dark-opacity"
            onClick={() => {
              handleBeneAccModalClose();
            }}
          >
            <LargePopupRedirect
              headerTitle="Request Account Details"
              headerFontWeight="semibold"
              headerFontColor="text-primary"
              headersubtext=""
              headertextSize="font-md"
              isfullViewrequired={true}
              fullviewbtnText="Open in full view"
              fullviewbtnType="button"
              fullviewhandleFunction={() => {
                handleBeneAccModalClose();
                // navigate(
                //   `/field_force_transaction_dashboard/field_force_transaction_view_all/field_force_transaction_detail_page/${fieldForceRequestDetailsData?.request?.[0]?.field_force_account_id}`,
                // );
                toast.info("Coming Soon...", toast_position);
              }}
              fullviewisDisabled={false}
              fullviewenabledTextColor="var(--text-primary)"
              fullviewenabledBgColor="var(--primary-nav)"
              fullviewdisabledBgColor="var(--text-disabled)"
              fullviewhoverOption="white"
              fullviewicon={ICONS?.REDIRECT}
              closeiconbtnType="button"
              closeiconhandleFunction={handleBeneAccModalClose}
              closeiconisDisabled={false}
              closeiconenabledBgColor="var(--primary-nav)"
              closeicondisabledBgColor="var(--text-disabled)"
              closeiconhoverOption="white"
              closeicon={ICONS?.CLOSE}
              isbottomSectionneed={false}
              bottomHeaderTextNeed={false}
              isscrollRequired={true}
            >
              <div onClick={(e) => e.stopPropagation()}>
                <FieldForceAccountDetailsPopup
                  field_force_account_id={
                    fieldForceRequestDetailsData?.request?.[0]
                      ?.field_force_account_id
                  }
                  closeBeneAccountDetailModal={handleBeneAccModalClose}
                  type={"fieldforceacc_details"}
                  payload={{
                    bene_account_id:
                      fieldForceRequestDetailsData?.request?.[0]
                        ?.field_force_account_id,
                    // type: "fieldforceacc_details",
                  }}
                  // servicesType="FFAAccount"
                />
              </div>
            </LargePopupRedirect>
          </div>
        )}
        {!isPopup && (
          <>
            <div className="sched-mobile-nav-bar fixed top-top-base left-left-base mt-margin-base w-width-full z-z-index-overlay bg-primary-nav shadow-box-shadow-bottom lg:hidden block">
              <div
                className="px-padding-md py-padding-sm  flex flex-row items-center gap-gap-sm"
                onClick={() => {
                  navigate(-1);
                }}
              >
                <div className=" mt-margin-xs cursor-pointer pt-px">
                  <SVGComponent
                    url={
                      "https://q2pay.in/new_assets/common/arrows/arrow_left_white.svg"
                    }
                    color="var(--text-primary)"
                    height={"var(--icon-sm)"}
                    width={"var(--icon-sm)"}
                  />
                </div>

                <div className="flex flex-col justify-center items-start">
                  <div className="text-font-md text-text-primary font-normal font-sans">
                    Field force
                  </div>
                  <div className="text-font-xs text-text-secondary font-normal font-sans">
                    Request detail
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
        {alertPopUp && (
          <div className="fixed top-top-base left-left-base w-width-full h-full flex items-center bg-PopUp-BackDrop justify-center z-z-index-modal bg-opacity-dark-opacity">
            <FullScreen
              id={txn_id ?? ""}
              setAlertPopUp={setAlertPopUp}
              type={"Schedule_Internal_Txn"}
            />
          </div>
        )}
        {!isPopup && (
          <div className="Qsmd:h-navbar-breadcrumb-height h-navbar-height bg-primary-nav hidden flex-shrink-0 Qmd:block"></div>
        )}

        {isloading ? (
          <div className="w-width-full flex-1 flex flex-row justify-center items-center">
            <Loader />
          </div>
        ) : (
          <>
            <div className={`bg-primary-bg`}>
              <>
                <div className="sched-detail-section hidden bg-primary-nav Qmd:flex flex-row justify-center relative">
                  <div
                    className={`sched-detail-section-inner-1024 Qlg:max-w-tab-width-normal Qlg:w-std-width Qmd:w-width-full relative `}
                  >
                    <div className="h-auto  flex flex-row justify-center items-stretch">
                      <div className="sched-schedule-name-div w-width-full flex flex-row justify-between items-center py-padding-md Qmd:w-width-md-2-3">
                        <div className="pl-padding-sm">
                          <TitleSubtitlePair
                            title={`INR ${formatCurrency(fieldForceRequestDetailsData?.request?.[0]?.amount)}`}
                            titleColor="settled"
                            subtitle={"Request amount"}
                            info={false}
                            alignRight={false}
                            hoverOption="white"
                            isBold={true}
                            variant="md"
                          />
                        </div>
                        {fieldForceRequestDetailsData?.request?.[0]
                          ?.lifecycle_status === "approved" && (
                          <div className="pl-padding-sm">
                            <TitleSubtitlePair
                              title={
                                fieldForceRequestDetailsData?.request?.[0]
                                  ?.request_amount
                                  ? `INR ${formatCurrency(fieldForceRequestDetailsData?.request?.[0]?.request_amount)}`
                                  : "NA"
                              }
                              titleColor="settled"
                              subtitle={"Approved amount"}
                              info={false}
                              textAlign={"right"}
                              hoverOption="white"
                              isBold={true}
                              variant="md"
                            />
                          </div>
                        )}
                      </div>

                      <div className="border-r border-solid border-primary-bg mx-margin-md my-margin-md"></div>
                      <div className="sched-txn-amount-div w-width-full flex flex-row justify-between items-center">
                        <div className="py-padding-md">
                          <TitleSubtitlePair
                            title={accountNameStandardised(
                              fieldForceRequestDetailsData?.request?.[0]
                                ?.field_force_account_name,
                            )}
                            titleColor="text-primary"
                            subtitle="Account name"
                            info={false}
                            alignRight={false}
                            hoverOption="white"
                            isBold={false}
                            variant="md"
                          />
                        </div>
                        <div className="hidden Qmd:flex flex-col justify-end gap-gap-base mr-margin_margin-md ml-margin-base h-height-full">
                          <div className="Qmd:flex flex-row overflow-hidden justify-end w-auto h-height-full">
                            <div className="min-w-splitview-btn-width px-padding-xl ml-margin-md py-padding-md box-border" />

                            {fieldForceRequestDetailsData?.request?.[0]
                              ?.lifecycle_status === "approved" ? (
                              <TopNavSmallButton
                                btnText={
                                  <>
                                    Linked <br /> transaction
                                  </>
                                }
                                icon={
                                  "https://q2pay.in/new_assets/common/detail_page/linked_white_circle.svg"
                                }
                                hoverOption={"white"}
                                enabledBgColor={"var(--primary-nav-act)"}
                                enabledTextColor={"var(--text-primary)"}
                                disabledBgColor={"var(--primary-nav-act)"}
                                disabledTextColor={"var(--text-primary)"}
                                handleFunction={() => {
                                  // navigate(
                                  //   `/field_force_transaction_dashboard/field_force_transaction_view_all/field_force_transaction_detail_page/${fieldForceRequestDetailsData?.request?.[0]?.field_force_transactions_details?.field_force_transaction_id}`,
                                  // );
                                  toast.info(
                                    "Feature coming soon!",
                                    toast_position,
                                  );
                                }}
                                isDisabled={isPopup}
                              />
                            ) : (
                              <TopNavSmallButton
                                btnText={
                                  <>
                                    Request <br /> history
                                  </>
                                }
                                btnType="button"
                                icon={
                                  "https://q2pay.in/new_assets/common/detail_page/transaction_history.svg"
                                }
                                handleFunction={() => {
                                  if (isPopup) {
                                    CommonToast({
                                      text: "Action restricted in popup mode.",
                                      icon: "https://q2pay.in/new_assets/common/create_flow/error_with_white_circle.svg",
                                      variant: "var(--error)",
                                    });
                                    return;
                                  } else {
                                    setRequestHistory(true);
                                    setRequestId(
                                      fieldForceRequestDetailsData?.request?.[0]
                                        ?.field_force_account_id,
                                    );
                                    setRequestAccName(
                                      fieldForceRequestDetailsData?.request?.[0]
                                        ?.field_force_account_name,
                                    );
                                  }
                                  // toast.info(
                                  //   "Feature coming soon!",
                                  //   toast_position,
                                  // );
                                }}
                                isDisabled={isPopup}
                                enabledTextColor="var(--text-primary)"
                                enabledBgColor="var(--primary-nav-act)"
                                disabledBgColor="var(--primary-nav-act)"
                                disabledTextColor="var(--text-primary)"
                                hoverOption="white"
                              />
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                    <hr className="border-primary-bg"></hr>
                    {fieldForceRequestDetailsData?.request?.[0]
                      ?.lifecycle_status === "approved" ? (
                      <div className="flex flex-row justify-center relative">
                        <div className="sched-source-side w-width-full flex flex-col  justify-between Qmd:pb-padding-md Qmd:pt-padding-sm Qmd:w-width-md-2-3">
                          <div className="sched-source-acct-bank  flex flex-row items-center justify-between w-width-full Qmd:pr-padding-sm ">
                            <div
                              className={`${
                                isPopup || !services?.includes("VAccount")
                                  ? "p-padding-sm"
                                  : ""
                              }`}
                            >
                              <TitleSubtitlePair
                                isDisabled={
                                  isPopup || !services?.includes("VAccount")
                                    ? true
                                    : false
                                }
                                alignRight={false}
                                // title={formatAccountNumber(
                                //   fieldForceRequestDetailsData?.request?.[0]
                                //     ?.owner_account_bank_acc_no,
                                // )}
                                title={formatAccountNumber(
                                  fieldForceRequestDetailsData?.request?.[0]
                                    ?.owner_account_bank_acc_no ??
                                    "50200002540472",
                                )}
                                titleColor={"text-primary"}
                                subtitle={TEXT?.SOURCE_ACCOUNT}
                                onClick={() => {
                                  // if (isPopup) {
                                  //   CommonToast({
                                  //     text: "Action restricted in popup mode.",
                                  //     icon: "https://q2pay.in/new_assets/common/create_flow/error_with_white_circle.svg",
                                  //     variant: "var(--error)",
                                  //   });
                                  // }
                                  // if (!services?.includes("VAccount")) {
                                  //   navigate("/feature_not_assigned", {
                                  //     state: {
                                  //       unavailableService: "VAccount",
                                  //     },
                                  //   });
                                  //   return;
                                  // } else {
                                  //   setOwnerDetailpop(true);
                                  // }
                                  toast.info(
                                    "Feature coming soon!",
                                    toast_position,
                                  );
                                }}
                                info={false}
                                showArrow={true}
                                hoverOption={"white"}
                                isBold={false}
                                variant={"md"}
                              />
                            </div>

                            <CommonBankLogo
                              // ifsc={
                              //   fieldForceRequestDetailsData?.request?.[0]
                              //     ?.owner_account_ifsc_code
                              // }
                              ifsc={
                                fieldForceRequestDetailsData?.request?.[0]
                                  ?.owner_account_ifsc_code
                              }
                              variant="big"
                              type="pill"
                            />
                          </div>
                          <div className="sched-source-ifsc-method flex flex-row justify-between items-center w-width-full">
                            <div className="Icode lg:flex flex-col gap-y-gap-xs mr-margin-lg w-width-lg pl-padding-sm">
                              <TitleSubtitlePair
                                isDisabled={false}
                                alignRight={false}
                                // title={
                                //   fieldForceRequestDetailsData?.request?.[0]
                                //     ?.owner_account_ifsc_code
                                // }
                                title={
                                  fieldForceRequestDetailsData?.request?.[0]
                                    ?.owner_account_ifsc_code
                                }
                                titleColor={"text-primary"}
                                subtitle={TEXT?.IFSC_CODE}
                                info={false}
                                showArrow={false}
                                isBold={false}
                                variant={"md"}
                              />
                            </div>

                            {fieldForceRequestDetailsData?.request?.[0]
                              ?.lifecycle_status === "approved" && (
                              <div className="Icode lg:flex flex-col gap-y-gap-xs w-width-lg pr-padding-sm">
                                <TitleSubtitlePair
                                  isDisabled={false}
                                  alignRight={false}
                                  textAlign={"right"}
                                  title={
                                    fieldForceRequestDetailsData?.request?.[0]
                                      ?.payment_method
                                  }
                                  titleColor={"text-primary"}
                                  subtitle={"Payment method"}
                                  info={false}
                                  showArrow={false}
                                  isBold={false}
                                  variant={"md"}
                                />
                              </div>
                            )}

                            {/* Desktop */}
                          </div>
                        </div>
                        <div className="sep-w-arrow my-auto h-full flex flex-shrink-0 flex-col justify-center items-center">
                          <div className="verical-filler absolute border-l border-l-primary-bg h-height-vertical"></div>
                          <div className="arrow-icon bg-primary-nav px-padding-xs py-padding-sm relative">
                            <img
                              src={ICONS?.ARROW_RIGHT_BLUE_CIRCLE}
                              alt="CircledWhiteArrow"
                              className="w-icon-md h-icon-md"
                            />
                          </div>
                        </div>

                        <div
                          className={`sched-dest-side w-width-full flex flex-col ${"justify-around"}`}
                        >
                          <div className="sched-dest-acct-bank flex flex-row justify-between w-width-full">
                            <div
                              className={`flex justify-between mr-margin-md w-full pt-padding-sm Qmd:w-width-md-2-3`}
                            >
                              <div style={{ height: "fit-content" }}>
                                <TitleSubtitlePair
                                  isDisabled={
                                    isPopup ||
                                    !(
                                      services?.includes("FFVAccount") ||
                                      services?.includes("Admin")
                                    )
                                      ? true
                                      : false
                                  }
                                  alignRight={false}
                                  title={formatAccountNumber(
                                    fieldForceRequestDetailsData?.request?.[0]
                                      ?.field_force_account_bank_acc_no,
                                  )}
                                  titleColor={"text-primary"}
                                  subtitle={"Destination account"}
                                  onClick={() => {
                                    if (isPopup) {
                                      CommonToast({
                                        text: "Action restricted in popup mode.",
                                        icon: "https://q2pay.in/new_assets/common/create_flow/error_with_white_circle.svg",
                                        variant: "var(--error)",
                                      });
                                    } else {
                                      if (
                                        services?.includes("FFVAccount") ||
                                        services?.includes("Admin")
                                      ) {
                                        setReimburseAccountDetailpop(true);
                                        setBeneAccountId(
                                          fieldForceRequestDetailsData
                                            ?.request?.[0]
                                            ?.field_force_account_id,
                                        );
                                      } else {
                                        navigate("/feature_not_assigned", {
                                          state: {
                                            unavailableService:
                                              "FFVAccount, Admin",
                                          },
                                        });
                                      }
                                    }
                                    // toast.info(
                                    //   "Feature coming soon!",
                                    //   toast_position,
                                    // );
                                  }}
                                  info={false}
                                  showArrow={true}
                                  hoverOption={"white"}
                                  isBold={false}
                                  variant={"md"}
                                />
                              </div>
                              <div className="sched-dest-bank rounded-full h-icon-lg flex bg-text-primary flex-row items-center px-padding-sm py-padding-button-s mt-margin-button-l justify-end ml-margin-sm">
                                <CommonBankLogo
                                  ifsc={
                                    fieldForceRequestDetailsData?.request?.[0]
                                      ?.field_force_account_ifsc_code
                                  }
                                  variant="big"
                                />
                              </div>
                            </div>
                            <div className="hidden Qmd:flex flex-col justify-end gap-gap-base mr-margin_margin-md ml-margin-base h-height-full">
                              <div className="Qmd:flex flex-row overflow-hidden justify-end h-height-full">
                                <div className="w-positive-negative-btn-width px-padding-xl  py-padding-md box-border" />
                                <div className="w-positive-negative-btn-width">
                                  <TopNavSmallButton
                                    key="Request-history"
                                    btnText={
                                      <>
                                        Request <br /> history
                                      </>
                                    }
                                    btnType="button"
                                    icon={
                                      "https://q2pay.in/new_assets/common/detail_page/transaction_history.svg"
                                    }
                                    handleFunction={() => {
                                      if (isPopup) {
                                        CommonToast({
                                          text: "Action restricted in popup mode.",
                                          icon: "https://q2pay.in/new_assets/common/create_flow/error_with_white_circle.svg",
                                          variant: "var(--error)",
                                        });
                                        return;
                                      } else {
                                        setRequestHistory(true);
                                        setRequestId(
                                          fieldForceRequestDetailsData
                                            ?.request?.[0]
                                            ?.field_force_account_id,
                                        );
                                        setRequestAccName(
                                          fieldForceRequestDetailsData
                                            ?.request?.[0]
                                            ?.field_force_account_name,
                                        );
                                      }
                                      // toast.info(
                                      //   "Feature coming soon!",
                                      //   toast_position,
                                      // );
                                    }}
                                    isDisabled={isPopup}
                                    enabledTextColor="var(--text-primary)"
                                    enabledBgColor="var(--primary-nav-act)"
                                    disabledBgColor="var(--primary-nav-act)"
                                    disabledTextColor="var(--text-primary)"
                                    hoverOption="white"
                                    fullWidthRequired
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                          <div
                            className={`sched-dest-ifsc flex flex-row gap-x-gap-md w-width-full pl-padding-sm items-end justify-between`}
                          >
                            <div className="flex justify-between mr-margin-md w-full pb-padding-md">
                              <TitleSubtitlePair
                                isDisabled={false}
                                alignRight={false}
                                title={
                                  fieldForceRequestDetailsData?.request?.[0]
                                    ?.field_force_account_ifsc_code || "N/A"
                                }
                                titleColor={"text-primary"}
                                subtitle={TEXT?.IFSC_CODE}
                                info={false}
                                showArrow={false}
                                isBold={false}
                                variant={"md"}
                              />
                            </div>
                            <div className="hidden Qmd:flex flex-col justify-end gap-gap-base mr-margin_margin-md ml-margin-base h-height-full">
                              <div className="Qmd:flex flex-row overflow-hidden justify-end  h-height-full">
                                <div
                                  className={`hidden Qmd:flex flex-row justify-end align-bottom h-auto`}
                                  style={{
                                    width:
                                      "calc(var(--positive-negative-btn-width) + var(--positive-negative-btn-width))",
                                  }}
                                >
                                  <div className="w-width-md overflow-hidden">
                                    <div className="border-t border-solid border-primary-bg " />
                                    <TopNavSmallButton
                                      btnText={
                                        fieldForceRequestDetailsData
                                          ?.request?.[0]?.category
                                      }
                                      btnType="button"
                                      icon={categoryIcon}
                                      handleFunction={() => {
                                        if (isPopup) {
                                          CommonToast({
                                            text: "Action restricted in popup mode.",
                                            icon: "https://q2pay.in/new_assets/common/create_flow/error_with_white_circle.svg",
                                            variant: "var(--error)",
                                          });
                                          return;
                                        } else {
                                          setRequestHistory(true);
                                          setRequestCategoryName(
                                            fieldForceRequestDetailsData
                                              ?.request?.[0]?.category,
                                          );
                                          setRequestAccName(
                                            fieldForceRequestDetailsData
                                              ?.request?.[0]
                                              ?.field_force_account_name,
                                          );
                                          setRequestId(
                                            fieldForceRequestDetailsData
                                              ?.request?.[0]
                                              ?.field_force_account_id,
                                          );
                                        }
                                        // toast.info(
                                        //   "Feature coming soon!",
                                        //   toast_position,
                                        // );
                                      }}
                                      isDisabled={isPopup ? true : false}
                                      enabledTextColor="var(--text-primary)"
                                      enabledBgColor="var(--primary-nav-act)"
                                      disabledBgColor="var(--primary-nav-act)"
                                      hoverOption="white"
                                      fullWidthRequired={false}
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    ) : (
                      <div className="flex flex-row justify-center relative">
                        <div className="sched-source-side w-width-full flex flex-col items-center justify-around Qmd:pb-padding-md Qmd:pt-padding-sm Qsmd:w-width-md-2-3">
                          <div
                            className={`sched-source-acct-bank Qmd:translate-x-[-0.5rem] flex flex-row items-center justify-between w-width-full pl-padding-sm`}
                          >
                            <div
                              className={` ${isPopup && "opacity-light-opacity"}`}
                            >
                              <TitleSubtitlePair
                                isDisabled={
                                  isPopup ||
                                  !(
                                    services?.includes("FFVAccount") ||
                                    services?.includes("Admin")
                                  )
                                    ? true
                                    : false
                                }
                                alignRight={false}
                                title={formatAccountNumber(
                                  fieldForceRequestDetailsData?.request?.[0]
                                    ?.field_force_account_bank_acc_no,
                                )}
                                titleColor={"text-primary"}
                                subtitle={"Destination account"}
                                onClick={() => {
                                  if (isPopup) {
                                    CommonToast({
                                      text: "Action restricted in popup mode.",
                                      icon: "https://q2pay.in/new_assets/common/create_flow/error_with_white_circle.svg",
                                      variant: "var(--error)",
                                    });
                                  } else {
                                    if (
                                      services?.includes("FFVAccount") ||
                                      services?.includes("Admin")
                                    ) {
                                      setReimburseAccountDetailpop(true);
                                      setBeneAccountId(
                                        fieldForceRequestDetailsData
                                          ?.request?.[0]
                                          ?.field_force_account_id,
                                      );
                                    } else {
                                      navigate("/feature_not_assigned", {
                                        state: {
                                          unavailableService:
                                            "FFVAccount, Admin",
                                        },
                                      });
                                    }
                                  }
                                  // toast.info(
                                  //   "Feature coming soon!",
                                  //   toast_position,
                                  // );
                                }}
                                info={false}
                                showArrow={true}
                                hoverOption={"white"}
                                isBold={false}
                                variant={"md"}
                              />
                            </div>

                            <div
                              className={`${isPopup && "opacity-light-opacity"} bg-text-primary rounded-full p-padding-sm flex flex-row justify-center items-center px-padding-sm py-padding-button-s mr-margin-md`}
                            >
                              <CommonBankLogo
                                ifsc={
                                  fieldForceRequestDetailsData?.request?.[0]
                                    ?.field_force_account_ifsc_code
                                }
                                variant="big"
                              />
                            </div>
                          </div>
                        </div>
                        <div className="border-r border-solid border-primary-bg mx-margin-md my-margin-md"></div>
                        <div
                          className={`sched-dest-side w-width-full flex flex-col  ${"justify-around"}`}
                        >
                          <div className="sched-dest-acct-bank flex flex-row items-center justify-between w-width-full h-full">
                            <div className="flex justify-between mr-margin-md w-full">
                              <TitleSubtitlePair
                                isDisabled={false}
                                alignRight={false}
                                title={
                                  fieldForceRequestDetailsData?.request?.[0]
                                    ?.field_force_account_ifsc_code
                                }
                                titleColor={"text-primary"}
                                subtitle={TEXT?.IFSC_CODE}
                                info={false}
                                showArrow={false}
                                isBold={false}
                                variant={"md"}
                              />
                            </div>
                            <div className="hidden Qmd:flex flex-col justify-end gap-gap-base mr-margin_margin-md ml-margin-base h-height-full">
                              <div className="Qmd:flex flex-row overflow-hidden justify-end  h-height-full">
                                <div
                                  className={`hidden Qmd:flex flex-row justify-end align-bottom h-auto`}
                                  style={{
                                    width:
                                      "calc(var(--positive-negative-btn-width) + var(--positive-negative-btn-width))",
                                  }}
                                >
                                  <div className="w-width-md overflow-hidden">
                                    <TopNavSmallButton
                                      btnText={
                                        fieldForceRequestDetailsData
                                          ?.request?.[0]?.category
                                      }
                                      btnType="button"
                                      icon={categoryIcon}
                                      handleFunction={() => {
                                        if (isPopup) {
                                          CommonToast({
                                            text: "Action restricted in popup mode.",
                                            icon: "https://q2pay.in/new_assets/common/create_flow/error_with_white_circle.svg",
                                            variant: "var(--error)",
                                          });
                                          return;
                                        } else {
                                          setRequestHistory(true);
                                          setRequestCategoryName(
                                            fieldForceRequestDetailsData
                                              ?.request?.[0]?.category,
                                          );
                                          setRequestAccName(
                                            fieldForceRequestDetailsData
                                              ?.request?.[0]
                                              ?.field_force_account_name,
                                          );
                                          setRequestId(
                                            fieldForceRequestDetailsData
                                              ?.request?.[0]
                                              ?.field_force_account_id,
                                          );
                                        }
                                        // toast.info(
                                        //   "Feature coming soon!",
                                        //   toast_position,
                                        // );
                                      }}
                                      isDisabled={isPopup ? true : false}
                                      enabledTextColor="var(--text-primary)"
                                      enabledBgColor="var(--primary-nav-act)"
                                      disabledBgColor="var(--primary-nav-act)"
                                      hoverOption="white"
                                      fullWidthRequired={false}
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
                <div
                  className={`h-mobile-navbar-height bg-primary-nav ${isPopup ? "hidden" : "Qmd:hidden block"}`}
                ></div>
                <div className="sched-detail-section-mobile flex flex-col Qmd:hidden w-width-full bg-primary-nav ">
                  <div className="sched-name-mobile flex flex-col p-padding-md">
                    <TitleSubtitlePair
                      title={`INR ${formatCurrency(fieldForceRequestDetailsData?.request?.[0]?.amount)}`}
                      titleColor="settled"
                      subtitle={"Request amount"}
                      info={false}
                      alignRight={false}
                      hoverOption="white"
                      isBold={true}
                      variant="md"
                    />
                  </div>
                  <hr className="border-primary-bg mx-margin-md Qmd:mx-margin-base"></hr>
                  {fieldForceRequestDetailsData?.request?.[0]
                    ?.lifecycle_status === "approved" && (
                    <>
                      <div className="sched-name-mobile flex flex-col p-padding-md">
                        <TitleSubtitlePair
                          title={
                            fieldForceRequestDetailsData?.request?.[0]
                              ?.request_amount
                              ? `INR ${formatCurrency(fieldForceRequestDetailsData?.request?.[0]?.request_amount)}`
                              : "NA"
                          }
                          titleColor="settled"
                          subtitle={"Approved amount"}
                          info={false}
                          alignRight={false}
                          hoverOption="white"
                          isBold={true}
                          variant="md"
                        />
                      </div>
                      <hr className="border-primary-bg mx-margin-md Qmd:mx-margin-base"></hr>
                    </>
                  )}

                  <div className="sched-amount-mobile flex flex-col p-padding-md">
                    <TitleSubtitlePair
                      title={(
                        fieldForceRequestDetailsData?.request?.[0]
                          ?.field_force_account_name || ""
                      )
                        .toLowerCase()
                        .split(" ")
                        .map(
                          (word) =>
                            word.charAt(0).toUpperCase() + word.slice(1),
                        )
                        .join(" ")}
                      titleColor="text-primary"
                      subtitle="Account name"
                      info={false}
                      alignRight={false}
                      hoverOption="white"
                      isBold={false}
                      variant="md"
                    />
                  </div>
                  <hr className="border-primary-bg mx-margin-md Qmd:mx-margin-base"></hr>

                  <div className="sched-accounts-jumbo-div-mobile flex flex-col Qlg:pl-padding-sm py-padding-sm">
                    {fieldForceRequestDetailsData?.request?.[0]
                      ?.lifecycle_status === "approved" && (
                      <>
                        <div className=" flex flex-col justify-between">
                          <div className=" sched-detail-src-acct-logo-mobile flex items-center pb-padding-sm w-full justify-between">
                            {" "}
                            <div className="ml-margin-sm Qlg:ml-margin-base">
                              <TitleSubtitlePair
                                isDisabled={
                                  !services?.includes("VAccount") ? true : false
                                }
                                alignRight={false}
                                // title={formatAccountNumber(
                                //   fieldForceRequestDetailsData?.request?.[0]
                                //     ?.owner_account_bank_acc_no,
                                // )}
                                title={formatAccountNumber(
                                  fieldForceRequestDetailsData?.request?.[0]
                                    ?.owner_account_bank_acc_no ??
                                    "50200002540472",
                                )}
                                titleColor={"text-primary"}
                                subtitle={TEXT?.SOURCE_ACCOUNT}
                                onClick={() => {
                                  // if (!services?.includes("VAccount")) {
                                  //   navigate("/feature_not_assigned", {
                                  //     state: {
                                  //       unavailableService: "VAccount",
                                  //     },
                                  //   });
                                  //   return;
                                  // } else {
                                  //   setOwnerDetailpop(true);
                                  // }
                                  toast.info(
                                    "Feature coming soon!",
                                    toast_position,
                                  );
                                }}
                                info={false}
                                showArrow={true}
                                hoverOption={"white"}
                                isBold={false}
                                variant={"md"}
                              />
                            </div>
                            <div className="bg-text-primary rounded-full h-[max-content] p-padding-sm flex flex-row justify-center items-center px-padding-sm py-padding-button-s mr-margin-md">
                              <CommonBankLogo
                                // ifsc={
                                //   fieldForceRequestDetailsData?.request?.[0]
                                //     ?.owner_account_ifsc_code
                                // }
                                ifsc={
                                  fieldForceRequestDetailsData?.request?.[0]
                                    ?.owner_account_ifsc_code ?? "HDFC0002819"
                                }
                                variant="big"
                              />
                            </div>
                          </div>

                          <div className="border-b border-solid border-primary-bg mx-margin-md w-width-full"></div>
                          <div className=" px-padding-md pt-padding-md">
                            {" "}
                            <TitleSubtitlePair
                              isDisabled={false}
                              alignRight={false}
                              // title={
                              //   fieldForceRequestDetailsData?.request?.[0]
                              //     ?.owner_account_ifsc_code
                              // }
                              title={
                                fieldForceRequestDetailsData?.request?.[0]
                                  ?.owner_account_ifsc_code ??
                                "HDFC0002819 khkfdjgkfj"
                              }
                              titleColor={"text-primary"}
                              subtitle={TEXT?.IFSC_CODE}
                              info={false}
                              showArrow={false}
                              isBold={false}
                              variant={"md"}
                            />
                          </div>
                        </div>

                        <div className="tri-spacing-div flex flex-row gap-gap-md justify-around items-center Qlg:pr-padding-md mx-margin-md">
                          <div className="border-b border-solid border-primary-bg w-width-full"></div>
                          <img
                            src={ICONS?.ARROW_DOWN_BLUE_WHITE}
                            alt="arrowDownBlueWhite"
                            className="w-icon-md"
                          />
                          <div className="border-b border-solid border-primary-bg w-width-full"></div>
                        </div>
                      </>
                    )}

                    <div
                      className={`sched-detail-src-acct-logo-mobile flex flex-row items-center  ${isPopup && "opacity-light-opacity"} justify-between`}
                    >
                      <div className="ml-margin-sm lg:ml-0">
                        <TitleSubtitlePair
                          isDisabled={
                            isPopup
                              ? true
                              : !(
                                    services?.includes("FFVAccount") ||
                                    services?.includes("Admin")
                                  )
                                ? true
                                : false
                          }
                          alignRight={false}
                          title={formatAccountNumber(
                            fieldForceRequestDetailsData?.request?.[0]
                              ?.field_force_account_bank_acc_no,
                          )}
                          titleColor={"text-primary"}
                          subtitle={"Destination account"}
                          onClick={() => {
                            if (isPopup) {
                              CommonToast({
                                text: "Action restricted in popup mode.",
                                icon: "https://q2pay.in/new_assets/common/create_flow/error_with_white_circle.svg",
                                variant: "var(--error)",
                              });
                            } else {
                              if (
                                services?.includes("FFVAccount") ||
                                services?.includes("Admin")
                              ) {
                                setReimburseAccountDetailpop(true);
                                setBeneAccountId(
                                  fieldForceRequestDetailsData?.request?.[0]
                                    ?.field_force_account_id,
                                );
                              } else {
                                navigate("/feature_not_assigned", {
                                  state: {
                                    unavailableService: "FFVAccount, Admin",
                                  },
                                });
                              }
                            }
                            // toast.info("Feature coming soon!", toast_position);
                          }}
                          info={false}
                          showArrow={true}
                          hoverOption={"white"}
                          isBold={false}
                          variant={"md"}
                        />
                      </div>
                      <div className="bg-text-primary rounded-full p-padding-sm flex flex-row justify-center items-center px-padding-sm py-padding-button-s mr-margin-md">
                        <CommonBankLogo
                          ifsc={
                            fieldForceRequestDetailsData?.request?.[0]
                              ?.field_force_account_ifsc_code
                          }
                          variant="big"
                        />
                      </div>
                    </div>
                  </div>

                  <hr className="border-primary-bg mx-margin-md Qmd:mx-margin-base"></hr>
                  <div className="sched-method-mobile flex flex-col gap-gap-xs p-padding-md">
                    <TitleSubtitlePair
                      isDisabled={false}
                      alignRight={false}
                      title={
                        fieldForceRequestDetailsData?.request?.[0]
                          ?.field_force_account_ifsc_code || "N/A"
                      }
                      titleColor={"text-primary"}
                      subtitle={TEXT?.IFSC_CODE}
                      info={false}
                      showArrow={false}
                      isBold={false}
                      variant={"md"}
                    />
                  </div>

                  {fieldForceRequestDetailsData?.request?.[0]
                    ?.lifecycle_status === "approved" && (
                    <>
                      <hr className="border-primary-bg mx-margin-md Qmd:mx-margin-base"></hr>
                      <div className="sched-method-mobile flex flex-col gap-gap-xs p-padding-md">
                        <TitleSubtitlePair
                          isDisabled={false}
                          alignRight={false}
                          title={
                            fieldForceRequestDetailsData?.request?.[0]
                              ?.payment_method
                          }
                          titleColor={"text-primary"}
                          subtitle={"Payment method"}
                          info={false}
                          showArrow={false}
                          isBold={false}
                          variant={"md"}
                        />
                      </div>
                    </>
                  )}
                </div>
              </>

              <div className="block Qmd:hidden">
                {scheduleUpdatedData?.transaction?.map((schedule) => {
                  return (
                    <TimelineStatusBar
                      showMobile={true}
                      overrideAutoLoader
                      whichBtnClicked={
                        btnClicked?.[
                          fieldForceRequestDetailsData?.request?.[0]?.request_id
                        ] || "none"
                      }
                      // isLoading={reimbursementRequestDetailsLoading}
                      failedToTakeaction={
                        timelinedatabottom?.message || rejectErrorMessage
                      }
                      failedToTakeactionReason={
                        scheduleUpdatedData?.message || rejectErrorMessage
                      }
                      accountApprovalPending={
                        fieldForceRequestDetailsData?.request?.[0]
                          ?.field_force_account_approval_status === "pending" &&
                        fieldForceRequestDetailsData?.request?.[0]
                          ?.lifecycle_status === "pending"
                      }
                      accountApprovalPendingSubHeader={
                        services?.includes("FFAAccount")
                          ? "Account is not approved, approve account before approving transaction."
                          : "To approve the account, please contact the authorized person."
                      }
                      handleApprovalPendingBtn={() => {
                        if (services?.includes("FFAAccount")) {
                          setShowRequestAccModal(true);
                        } else {
                          navigate("/feature_not_assigned", {
                            state: {
                              unavailableService: "FFAAccount",
                            },
                          });
                        }
                      }}
                      requestApproval={
                        fieldForceRequestDetailsData?.request?.[0]?.approved ===
                        "Y"
                      }
                      handleRequestApproval={() => {
                        if (
                          services?.includes("VFieldForceTxn") ||
                          services?.includes("Admin")
                        ) {
                          // navigate(
                          //   `/field_force_transaction_dashboard/field_force_transaction_view_all/field_force_transaction_detail_page/${scheduleUpdatedData?.request?.[0]?.field_force_transactions_details?.field_force_transaction_id}`,
                          // );
                          toast.info("Coming Soon...", toast_position);
                        } else {
                          navigate("/feature_not_assigned", {
                            state: {
                              unavailableService: "VFieldForceTxn",
                            },
                          });
                        }
                      }}
                      isReqDisable={
                        !services?.includes("VFieldForceTxn") &&
                        !services?.includes("Admin")
                      }
                      isApprovalPendingDisabled={
                        !services?.includes("FFAAccount")
                      }
                      rejected={
                        fieldForceRequestDetailsData?.request?.[0]?.rejected ===
                        "Y"
                      }
                      rejectedReason={
                        fieldForceRequestDetailsData?.request?.[0]
                          ?.rejection_reason
                      }
                      pending={
                        !(
                          fieldForceRequestDetailsData?.request?.[0]
                            ?.approved === "Y"
                        ) &&
                        !(
                          fieldForceRequestDetailsData?.request?.[0]
                            ?.rejected === "Y"
                        ) &&
                        !rejectErrorMessage
                      }
                      rejectMobClick={() => {
                        if (hasModService) {
                          setbtnClicked((prev) => ({
                            ...prev,
                            [fieldForceRequestDetailsData?.request?.[0]
                              ?.request_id]: "Reject",
                          }));
                          setShowRejectPrompt(true);
                        } else {
                          navigate("/feature_not_assigned", {
                            state: {
                              unavailableService: "AFieldForceRequest",
                            },
                          });
                        }
                      }}
                      isRejectMobDisable={
                        !services?.includes("AFieldForceRequest")
                      }
                      approveBtnText={
                        <>
                          Approve and <br /> pay
                        </>
                      }
                      rejectBtnText={
                        <>
                          Reject <br /> request
                        </>
                      }
                      approveMobClick={() => {
                        if (services?.includes("AFieldForceRequest")) {
                          const updatedAccountDetails = {
                            request_id: schedule?.request_id,
                            bankAccountName: schedule?.field_force_account_name,
                            beneAccountId: schedule?.field_force_account_id,
                            bankAccountIFSC:
                              schedule?.field_force_account_ifsc_code,
                            bankAccountNo:
                              schedule?.field_force_account_bank_acc_no,
                            categories: schedule?.category,
                            amount: schedule?.amount || "NA",
                            bankLogo: schedule?.field_force_account_ifsc_code,
                            pan: "",
                            ownerId: null,
                            ownerAccountName: "",
                            ownerBankIFSC: null,
                            ownerBankBalance:
                              GlobalConfiguration.lengthCheckZero,
                            ownerBankLogo: null,
                            ownerLastUpdated: null,
                            ownerBankAccountNo: null,
                            selectedCategory: {
                              configuration: schedule?.additional_data,
                            },
                            mergeCategory: schedule?.additional_data?.data,
                            amountWords: "",
                            labels: schedule?.labels || [],
                            ownerLabels: [],
                            comment: "",
                            // date: schedule?.reimbursement_date,
                            date: schedule?.request_date,
                            expenseType: schedule?.expense_type,
                            description:
                              currentAccountDetails?.description ?? "",
                            uploadFile: schedule?.uploaded_file_data,
                          };

                          setcurrentAccountDetails(updatedAccountDetails);

                          navigate(
                            "/field_force_transaction_dashboard/create_field_force_transaction",
                            {
                              state: {
                                ...updatedAccountDetails,
                                type: "PayReimburseTxn",
                                flow: "PayReimburseTxn",
                                TypeRTGS: "RequestRTGS",
                              },
                            },
                          );
                        } else {
                          navigate("/feature_not_assigned", {
                            state: {
                              unavailableService: "AFieldForceRequest",
                            },
                          });
                        }
                      }}
                      isApproveMobDisable={!hasModService}
                    />
                  );
                })}
              </div>

              <div className="sched-bottom-section flex flex-row justify-center bg-primary-bg">
                <div
                  className={`sched-bottom-section-inner-1024 max-w-screen-Qlg 
                    ${
                      fieldForceRequestDetailsData?.request?.[0]
                        ?.lifecycle_status === "approved"
                        ? rejectErrorMessage
                          ? "mt-margin-sm"
                          : "mt-margin-md"
                        : "mt-0"
                    }
                    ${!isPopup ? "Qmd:w-max-content-width" : " mr-margin-base "} w-width-full pl-padding-base `}
                >
                  <div className="sched-quick-details-container-mobile block Qmd:hidden">
                    {quickActions}
                  </div>
                  <>
                    <div
                      className={`  Qlg:mx-margin-base mx-margin-md flex flex-row mt-margin-md  items-end max-w-max-content-width max-h-max-height-top-slider min-h-stepper-header ${rejectErrorMessage ? "mt-margin-sm" : "Qsmd:mt-margin-base"} ${
                        !(
                          fieldForceRequestDetailsData?.request?.[0]
                            ?.approved === "Y" ||
                          fieldForceRequestDetailsData?.request?.[0]
                            ?.rejected === "Y"
                        )
                          ? "Qsmd:justify-center"
                          : "justify-start"
                      }`}
                    >
                      <div
                        className={`bg-primary-card rounded-t-border-radius-md  rounded-bl-border-radius-md w-width-full Qlg:w-[calc(var(--graphic-rectangle-height-lg)-(var(--banklogo-height-sm)))] Qmd:w-width-sm  ${fieldForceRequestDetailsData?.request?.[0]?.rejected === "Y" ? "rounded-bl-border-radius-md rounded-br-border-radius-md Qsmd:rounded-br-none" : "Qsmd:rounded-br-none rounded-br-border-radius-md"}`}
                      >
                        <div
                          className={`sched-txn-timeline-status-container ${isPopup && "opacity-light-opacity cursor-not-allowed"} bg-primary-nav relative z-z-index-content rounded-border-radius-md w-width-full ${isPopup ? "cursor-not-allowed" : " "}`}
                        >
                          <div className="text-text-primary text-font-xs text-left font-semibold pt-padding-sm mb-margin-sm px-padding-md">
                            Request timeline
                          </div>
                          <div className="relative left-left-base border-primary-bg border-t-border mx-margin-md"></div>

                          <div
                            ref={leftContentRef}
                            className={`bg-primary-nav group relative  rounded-b-border-radius-md w-full z-z-index-base`}
                          >
                            <CommonTimeLineCard
                              logsData={scheduleUpdatedData?.transaction}
                              handleApprovalClick={handleTimelinePopup}
                              showApprovalTimeline={true}
                              showDistributionTimeline={false}
                              showDistributionRightIcon={true}
                              showApprovalLeftIcon={true}
                              showApprovalDuration={true}
                              showDistributionDuration={false}
                              isDisabled={isPopup}
                              cardType={"single"}
                              leftCardTitle="Stage - Approval"
                            />
                          </div>
                        </div>
                      </div>

                      <div className="hidden Qmd:flex flex-col flex-grow  w-width-md">
                        {/* Web  */}
                        {scheduleUpdatedData?.transaction?.map((schedule) => {
                          return (
                            <TimelineStatusBar
                              overrideAutoLoader
                              hasDistributionData={false}
                              showMobile={false}
                              // isLoading={reimbursementRequestDetailsLoading}
                              whichBtnClicked={
                                btnClicked?.[
                                  fieldForceRequestDetailsData?.request?.[0]
                                    ?.request_id
                                ] || "none"
                              }
                              failedToTakeaction={
                                timelinedatabottom?.message ||
                                rejectErrorMessage
                              }
                              failedToTakeactionReason={
                                scheduleUpdatedData?.message ||
                                rejectErrorMessage
                              }
                              accountApprovalPending={
                                fieldForceRequestDetailsData?.request?.[0]
                                  ?.field_force_account_approval_status ===
                                  "pending" &&
                                fieldForceRequestDetailsData?.request?.[0]
                                  ?.lifecycle_status === "pending"
                              }
                              accountApprovalPendingSubHeader={
                                services?.includes("FFAAccount")
                                  ? "Account is not approved, approve account before approving transaction."
                                  : "To approve the account, please contact the authorized person."
                              }
                              handleApprovalPendingBtn={() => {
                                if (services?.includes("FFAAccount")) {
                                  setShowRequestAccModal(true);
                                } else {
                                  navigate("/feature_not_assigned", {
                                    state: {
                                      unavailableService: "FFAAccount",
                                    },
                                  });
                                }
                              }}
                              requestApproval={
                                fieldForceRequestDetailsData?.request?.[0]
                                  ?.approved === "Y"
                              }
                              handleRequestApproval={() => {
                                if (
                                  services?.includes("VFieldForceTxn") ||
                                  services?.includes("Admin")
                                ) {
                                  // navigate(
                                  //   `/field_force_transaction_dashboard/field_force_transaction_view_all/field_force_transaction_detail_page/${scheduleUpdatedData?.request?.[0]?.field_force_transactions_details?.field_force_transaction_id}`,
                                  // );
                                  toast.info("Coming Soon...", toast_position);
                                } else {
                                  navigate("/feature_not_assigned", {
                                    state: {
                                      unavailableService: "VFieldForceTxn",
                                    },
                                  });
                                }
                              }}
                              isReqDisable={
                                !services?.includes("VFieldForceTxn") &&
                                !services?.includes("Admin")
                              }
                              isApprovalPendingDisabled={
                                !services?.includes("FFAAccount")
                              }
                              rejected={
                                fieldForceRequestDetailsData?.request?.[0]
                                  ?.rejected === "Y"
                              }
                              rejectedReason={
                                fieldForceRequestDetailsData?.request?.[0]
                                  ?.rejection_reason
                              }
                              pending={
                                !(
                                  fieldForceRequestDetailsData?.request?.[0]
                                    ?.approved === "Y"
                                ) &&
                                !(
                                  fieldForceRequestDetailsData?.request?.[0]
                                    ?.rejected === "Y"
                                ) &&
                                !rejectErrorMessage
                              }
                              rejectClick={() => {
                                setbtnClicked((prev) => ({
                                  ...prev,
                                  [fieldForceRequestDetailsData?.request?.[0]
                                    ?.request_id]: "Reject",
                                }));
                                if (hasModService) {
                                  setShowRejectPrompt(true);
                                } else {
                                  navigate("/feature_not_assigned", {
                                    state: {
                                      unavailableService: "AFieldForceRequest",
                                    },
                                  });
                                }
                              }}
                              approveBtnText={
                                <>
                                  Approve and <br /> pay
                                </>
                              }
                              rejectBtnText={
                                <>
                                  Reject <br /> request
                                </>
                              }
                              isRejectDisable={
                                !services?.includes("AFieldForceRequest")
                              }
                              approveClick={() => {
                                if (services?.includes("AFieldForceRequest")) {
                                  const updatedAccountDetails = {
                                    request_id: schedule?.request_id,
                                    bankAccountName:
                                      schedule?.field_force_account_name,
                                    beneAccountId:
                                      schedule?.field_force_account_id,
                                    bankAccountIFSC:
                                      schedule?.field_force_account_ifsc_code,
                                    bankAccountNo:
                                      schedule?.field_force_account_bank_acc_no,
                                    categories: schedule?.category,
                                    amount: schedule?.amount,
                                    bankLogo:
                                      schedule?.field_force_account_ifsc_code,
                                    pan: "",
                                    ownerId: null,
                                    ownerAccountName: "",
                                    ownerBankIFSC: null,
                                    ownerBankBalance:
                                      GlobalConfiguration.lengthCheckZero,
                                    ownerBankLogo: null,
                                    ownerLastUpdated: null,
                                    ownerBankAccountNo: null,
                                    selectedCategory: {
                                      configuration: schedule?.additional_data,
                                    },
                                    mergeCategory:
                                      schedule?.additional_data?.data,
                                    amountWords: "",
                                    labels: schedule?.labels || [],
                                    ownerLabels: [],
                                    comment: "",
                                    // date: schedule?.reimbursement_date,
                                    date: schedule?.request_date,
                                    expenseType: schedule?.expense_type,
                                    description:
                                      currentAccountDetails?.description ?? "",
                                    uploadFile: schedule?.uploaded_file_data,
                                  };

                                  setcurrentAccountDetails(
                                    updatedAccountDetails,
                                  );

                                  navigate(
                                    "/field_force_transaction_dashboard/create_field_force_transaction",
                                    {
                                      state: {
                                        ...updatedAccountDetails,
                                        type: "PayReimburseTxn",
                                        flow: "PayReimburseTxn",
                                        TypeRTGS: "RequestRTGS",
                                      },
                                    },
                                  );
                                } else {
                                  navigate("/feature_not_assigned", {
                                    state: {
                                      unavailableService: "AFieldForceRequest",
                                    },
                                  });
                                }
                              }}
                              isApproveDisable={!hasModService}
                            />
                          );
                        })}
                      </div>
                    </div>
                  </>
                  <div className="sched-detail-container w-width-full overflow-x-hidden max-w-screen-Qlg bg-primary-bg  Qsmd:pr-padding-base pl-padding-base">
                    <>
                      <div className="py-padding-md flex pl-padding-md Qlg:pl-padding-base">
                        <div className="flex gap-gap-sm bg-primary-card w-auto lg:ml-margin-base rounded-border-radius-md overflow-x-auto">
                          <SwitcherTabs
                            initialActiveTab={
                              flow === "request_additional" ||
                              selectedDetail === "Additional details"
                                ? "Additional details"
                                : selectedDetail === "Labels"
                                  ? "Labels"
                                  : "Details"
                            }
                            tabs={[
                              {
                                label: "Details",
                                key: "Details",
                                handler: toggleDetails,
                              },
                              {
                                label: "Additional details",
                                key: "Additional details",
                                handler: toggleAdditionalDetails,
                              },
                            ]}
                            setTabIndex={setTabIndex}
                          />
                        </div>
                      </div>
                    </>
                    <div className="sched-detail-pane mb-margin-md">
                      {renderDetailSection()}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </>
  );
};
export default FieldForceTxnRequestDetail;
